<div class="d-flex gap-8 flex-grow-1 flex-direction-column">
  <div class="d-flex align-items-center justify-content-between gap-8">
    <div class="d-flex align-items-center gap-8 w-0 flex-grow-1">
      <button
        type="button"
        class="button button--sm button--primary-ghost text-uppercase"
        [disabled]="isLoading()"
        (click)="refresh.emit()"
      >
        <i class="ri-refresh-line" aria-hidden="true"></i>
        {{ 'Aktualisieren' | trans:'online-orders-search/actions/refresh.Button' }}
      </button>
    </div>

    <div class="d-flex align-items-center">
      <app-icon-switch
        [options]="statusFilterOptions"
        [selectedValue]="status()"
        (selectedValueChange)="statusChange.emit($event)"
      />
    </div>
  </div>

  <app-search (searchChange)="onSearchChange($event)" />

  @if (isLoading()) {
    <div class="d-flex justify-content-center full-height align-items-center">
      <app-loader size="lg" />
    </div>
  } @else if (orders().length > 0) {
    <table class="base full-width table-layout-fixed">
      <thead>
      <tr>
        <th width="34%">
          {{ 'Buchung# / Kunde' | trans:'online-orders-search/table/bookingCustomer.Text' }}
        </th>
        <th width="14%">
          {{ 'Kauf' | trans:'online-orders-search/table/purchaseDate.Text' }}
        </th>
        <th width="24%">
          {{ 'Produkte' | trans:'online-orders-search/table/products.Text' }}
        </th>
        <th width="8%">
          {{ 'Anzahl' | trans:'online-orders-search/table/quantity.Text' }}
        </th>
        <th width="12%">
          {{ 'Betrag' | trans:'online-orders-search/table/amount.Text' }}
        </th>
        <th></th>
      </tr>
      </thead>
      <tbody>
        @for (o of orders(); track o.transactionId) {
          <tr class="cursor-pointer" (click)="onRowClick(o)">
            <td>
              <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                {{ o.bookingCode }} / {{ (o.customerName || o.deliveryAddress) | empty }}
              </div>
            </td>
            <td>
              <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                {{ o.purchaseDate | dateFormat:'DD.MM. HH:mm' }}
              </div>
            </td>
            <td>
              <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                {{ o.products | empty }}
              </div>
            </td>
            <td>
              <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                {{ o.quantity }}
              </div>
            </td>
            <td>
              <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                {{ o.amount | numberToCurrency }} {{ languageConfig.currency.short }}
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center justify-content-flex-end">
                @if (o.status === onlineOrderStatuses.Open) {
                  <button
                    class="button button--icon-sm button--no-border c-t-blue-700"
                    (click)="$event.stopPropagation(); fulfilmentRequested.emit(o.transactionId)"
                    appTooltip
                    content="{{ 'Ausgeben' | trans:'online-orders-search/table/issue/button.Tooltip' }}"
                  >
                    <i class="ri-hand-coin-line"></i>
                  </button>
                }
                <button
                  class="button button--icon-sm button--no-border c-t-blue-700"
                  (click)="$event.stopPropagation(); detailsRequested.emit(o.transactionId)"
                  appTooltip
                  content="{{ 'Details' | trans:'online-orders-search/table/details/button.Tooltip' }}"
                >
                  <i class="ri-file-list-3-line"></i>
                </button>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <p>{{ 'Keine Online-Kartenbestellungen gefunden.' | trans:'online-orders-search/noOnlineOrdersFound.Text' }}</p>
  }

  <div class="m-t-24 d-flex justify-content-center">
    <app-pagination
      [pagination]="pagination()"
      [isDisabled]="isLoading()"
      (pageChange)="pageChange.emit($event)"
    />
  </div>
</div>
